/**
 * Черновик ответов тренажёра на устройстве.
 *
 * ⚠️ ЗАЧЕМ. 07.09.2026 заказчик написал: «Проставил некоторые ответы в
 * моке/reading/listening. Вышел — ответы обнулились». У мока и спринта
 * сохранение на сервер есть, а у чтения и аудирования не было ВООБЩЕ: ответы
 * жили только в памяти вкладки и умирали от любого ухода со страницы —
 * случайного «назад», звонка на телефоне, перезагрузки.
 *
 * ⚠️ ПОЧЕМУ НЕ НА СЕРВЕР, КАК У МОКА. У чтения и аудирования нет серверной
 * ручки для промежуточных ответов, а заводить её — это миграция, ручка,
 * права доступа: на день запуска слишком крупная работа ради того, чтобы
 * человек не терял работу при случайном выходе. Черновик на устройстве
 * закрывает ровно тот случай, на который жалуются, и не трогает сервер.
 *
 * Чего он не умеет: переехать на другое устройство и пережить чистку данных
 * браузера. Для попытки, которую делают за один присест, этого достаточно.
 */

const PREFIX = 'onebilim:draft:';

// Через две недели черновик уже никому не нужен, а место занимает.
const СРОК = 14 * 24 * 60 * 60 * 1000;

type Запись<T> = { at: number; v: T };

/**
 * ⚠️ ВСЁ В try/catch. В приватном окне и при запрете хранения данных сайта
 * обращение к localStorage не возвращает пусто, а БРОСАЕТ. Непойманная ошибка
 * здесь обрушила бы весь тренажёр — то есть попытка спасти ответы отняла бы
 * саму возможность отвечать.
 */
export function saveDraft<T>(key: string, value: T): void {
  try {
    const rec: Запись<T> = { at: Date.now(), v: value };
    localStorage.setItem(PREFIX + key, JSON.stringify(rec));
  } catch {
    /* хранение недоступно — работаем без черновика */
  }
}

export function loadDraft<T>(key: string): T | null {
  try {
    const raw = localStorage.getItem(PREFIX + key);
    if (!raw) return null;
    const rec = JSON.parse(raw) as Запись<T>;
    if (!rec || typeof rec.at !== 'number') return null;
    if (Date.now() - rec.at > СРОК) {
      localStorage.removeItem(PREFIX + key);
      return null;
    }
    return rec.v;
  } catch {
    return null;
  }
}

/**
 * Убрать черновик. Зовётся после успешной сдачи: иначе при следующем заходе
 * в ту же работу человек увидит свои старые ответы поверх чистого бланка и
 * решит, что сдача не прошла.
 */
export function clearDraft(key: string): void {
  try {
    localStorage.removeItem(PREFIX + key);
  } catch {
    /* нечего убирать */
  }
}
